<template>
  <slot :formatted="formatted" />
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from "#imports";
import { getRelativeTimeString } from "#blokkli/helpers";
const props = defineProps({
  timestamp: { type: Number, required: true }
});
const incrementToggle = ref(0);
let interval = null;
const formatted = computed(() => {
  const date = new Date(props.timestamp * 1e3 + incrementToggle.value);
  return getRelativeTimeString(date);
});
onMounted(() => {
  interval = setInterval(() => {
    incrementToggle.value = incrementToggle.value ? 0 : 1;
  }, 1e3);
});
onBeforeUnmount(() => {
  clearInterval(interval);
});
</script>

<script>
export default {
  name: "RelativeTime"
};
</script>
